/**
 * Rotas utilizadas no sideBar
 * Esses objetos são renderizados dinâmicamente de acordo com o módulo ativo
 */
export const sofiaRei = [
  {
    title: 'Registros',
    path: '/',
  },
  {
    title: 'Ordens de Serviços',
    options: [
      { title: 'Visualizar existentes', path: '/ordens-servicos' },
      { title: 'Adicionar nova', path: '/ordem-servico/novo' }
    ]
  },
  {
    title: 'Cadastro da serventia',
    path: '/cadastros/serventia'
  },
  {
    title: 'Gerenciador de tarefas',
    path: '/gerenciador'
  },
  {
    title: 'Livro Caixa',
    path: '/livro-caixa'
  },
  {
    title: 'Frente de Caixa',
    path: '/frente-de-caixa/caixa'},
  {
    title: 'Mensalistas',
    options: [
      {title: 'Cadastro de Mensalistas', path: '/mensalistas/cadastro-de-mensalistas'},
      {title: 'Serviços Realizados', path: '/mensalistas/servicos-realizados'},
      {title: 'Pagamento de Serviços Faturados', path: '/mensalistas/pagamentos-faturados'}
    ]
  },
  {
    title: 'Relatórios',
    //path: '/relatorios'
    options: [
      { title: 'Serviços Realizados e Recolhimentos', path: '/Relatorios/servicos-realizados-e-recolhimento' },
      { title: 'Listagem de Registros', path: '/Relatorios/listagem-registros' },
      { title: 'SEFAZ/SP', path: '/Relatorios/sefaz-sp' },
      { title: 'Polícia Federal', path: '/Relatorios/policia-federal' },
      { title: 'Relatório SIPET', path: '/Relatorios/sipet' },
      { title: 'Ministério da Defesa', path: '/Relatorios/ministerio-defesa' },
      { title: 'Selos', path: '/Relatorios/relatorio-selos' },
      { title: 'Relatórios Impressos de Segurança', path: '/Relatorios/impressos-seguranca'},
      { title: 'Cumprimento de Pedidos', path: '/Relatorios/cumprimento-pedidos'},
    ]
  },
  {
    title: 'Cadastros',
    options: [
      { title: 'Beneficiários', path: '/cadastros/beneficiarios'},
      { title: 'Categorias e Tipo de Ato', path: '/cadastros/categorias'},
      { title: 'Causa Morte', path: '/cadastros/causas-mortes'},
      { title: 'Custas', path: '/cadastros/custas'},
      { title: 'Funerárias', path: '/cadastros/funerarias'},
      { title: 'Hospitais', path: '/cadastros/hospitais'},
      // { title: 'Inteiro Teor', path: '/cadastros/inteiro-teor'},
      { title: 'Locais de Sepultamento', path: '/cadastros/locais-de-sepultamento'},
      { title: 'Regime de bens', path: '/cadastros/regime-de-bens'},
      // Tela de cadastro de Solicitantes indisponível para o usuário no momento
      //{ title: 'Solicitantes', path: '/cadastros/solicitantes'},
      { title: 'Minutas', path: '/cadastros/minutas'},
      { title: 'Natureza Protocolo', path: '/cadastros/natureza-protocolo'}
    ]
  },
  {
    title: 'Administração',
    options: [
      { title: 'Selos e OS Cancelados', path: '/administracao/selos-os-cancelados'},
      { title: 'Impressos de Segurança', path: '/papel-seguranca'},
      { title: 'Protocolos', path: '/protocolos'}
    ]
  },
  {
    title: 'Importar imagens em lote',
    path: '/importar-imagens-em-lote'
  }
]

export const sofia = []
export const eSinoreg = []
